import { Role } from '@/src/types/role.type'
import { DepartmentResMock, DepartmentsMock } from '../types/department.types'
import { FacilitySchema } from '../types/facility.type'
import { GeneralResMock } from '../types/general.type'
import { HmoResMock } from '../types/hmo.type'
import { IcdDataMock, IcdsResMock } from '../types/icd.type'
import { getError } from '../utils'
import AXIOS_INSTANCE from './axiosInstance'

export const icdsAction = async (query?: string): Promise<IcdDataMock[]> => {
  try {
    let endpoint = 'icd_codes?'
    endpoint += `sort_by=title&sort_dir=asc`
    if (query) endpoint += `&query=${encodeURIComponent(query)}`
    const { data } = await AXIOS_INSTANCE.get<IcdsResMock>(endpoint)
    return data.data
  } catch (error: any) {
    return error?.response
  }
}

export const hmoAction = async (query?: string): Promise<{ label: string; value: string }[]> => {
  try {
    let hmoList: { label: string; value: string }[] = []

    if (!query) {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<HmoResMock[]>>(`hmos`)
      hmoList = data.data?.map(({ attributes }) => ({
        label: attributes.name,
        value: attributes.name
      }))
    } else {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<HmoResMock[]>>(`hmos?query=${query}`)
      hmoList = data.data?.map(({ attributes }) => ({
        label: attributes.name,
        value: attributes.name
      }))
    }

    return hmoList
  } catch (error: any) {
    return error?.response
  }
}

export const deptAction = async (query?: string): Promise<{ label: string; value: string }[]> => {
  try {
    let endpoint = 'departments?'
    endpoint += `sort_by=name&sort_dir=asc`
    if (query) endpoint += `&query=${encodeURIComponent(query)}`
    const { data } = await AXIOS_INSTANCE.get<DepartmentResMock<DepartmentsMock[]>>(endpoint)
    return (data.data || [])?.map(department => ({
      label: department.attributes?.name,
      value: String(department.id)
    }))
  } catch (error: any) {
    return error?.response
  }
}

export const roleAction = async (query?: string): Promise<{ name: string; value: string }[]> => {
  let drugList: { name: string; value: string }[] = []
  try {
    const { data } = await AXIOS_INSTANCE.get<GeneralResMock<Role[]>>('roles', {
      params: { ...(query && { query: encodeURIComponent(query) }) }
    })
    drugList = (data.data || [])?.map(drug => ({
      name: drug.attributes?.name ?? '',
      value: drug.attributes?.name
    }))

    return drugList
  } catch (error: any) {
    getError(error)
  }
  return drugList
}

export const facilityAction = async (query?: string): Promise<{ label: string; value: string }[]> => {
  try {
    const { data } = await AXIOS_INSTANCE.get<GeneralResMock<FacilitySchema[]>>(`facilities`, {
      params: { ...(query && { query: encodeURIComponent(query) }), status: 'active' }
    })
    return data.data?.map(facility => ({ label: facility.attributes?.name, value: facility.id })) || []
  } catch (error: any) {
    return error?.response
  }
}
